import React, { useCallback, useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import PaymentTermCreateForm from './PaymentTermForm';

const { PRIVATE_ROUTE } = API_ROUTES;

function  PaymentTermForm() {
  const {id} = useParams();
  const { authAxios } = useContext(FetchContext);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, isSubmitting },
    setValue,
    control
  } = useForm({
    defaultValues: {
      name: '',
      remark: '',
    }});

  const getpaymentFormById = useCallback(async () => {
    const { data } = await authAxios.get(
      `${PRIVATE_ROUTE.GET_PAYMENTTERM_BY_ID}/${id}`
    );          
    setValue('name', data?.data.name);
    setValue('remark', data?.data.remark);
  }, [authAxios, id, setValue]);

  useEffect(() => {
    if (id) {
      getpaymentFormById();
    }
  }, [getpaymentFormById, id]);

  const onSubmit = async (data) => {
    if (id) {
      const response = await authAxios.post(
        `${PRIVATE_ROUTE?.EDIT_PAYMENTTERM}${id}`,
        data
      );
      toast.success(response.data.massage);
      navigate('/master/paymentterm/list');
    } else {
      const response = await authAxios.post(PRIVATE_ROUTE?.CREATE_PAYMENTTERM, data);
      if (response.data.statusCode === 200) {
        toast.success(response.data.massage);
        navigate('/master/paymentterm/list');
      }
      else {
        toast.error(response.data.massage);
      }
    }
    setValue('name', '');
    setValue('remark', '');
  };
  return (
    < PaymentTermCreateForm
      register={register}
      setValue={setValue}
      getValues={getValues}
      handleSubmit={handleSubmit}
      errors={errors}
      onSubmit={onSubmit}
      params={id}
      loading={isSubmitting}
      isEdit={id?"true":"false"}
      control={control}
    />
  );
}

export default  PaymentTermForm;
